import React, { useState } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import logisticsImg from "../../assets/1-header.png";

import { FaRobot, FaTruck } from "react-icons/fa";

const styles = `
  .logi-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .logi-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .logi-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .logi-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .logi-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logi-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .logi-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .logi-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .logi-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .logi-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .logi-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .logi-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .logi-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .logi-img-wrapper {
    flex: 1;
  }

  .logi-img-wrapper img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .logi-accordion {
    flex: 1.2;
  }

  .logi-accordion-item {
    margin-bottom: 18px;
  }

  .logi-accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .logi-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .logi-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .logi-header {
      height: auto;
      min-height: 90px;
    }

    .logi-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .logi-title-group h2 {
      font-size: 26px;
    }

    .logi-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .logi-header {
      flex-direction: column;
      height: auto;
    }

    .logi-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .logi-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .logi-triangle-left,
    .logi-triangle-right {
      width: 50px;
    }

    .logi-title-group h2 {
      font-size: 22px;
    }

    .logi-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .logi-img-wrapper {
      width: 100%;
    }

    .logi-img-wrapper img {
      max-width: 100%;
    }

    .logi-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .logi-header {
      flex-direction: column;
      height: auto;
    }

    .logi-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .logi-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .logi-header-badge span:first-of-type {
      font-size: 12px;
    }

    .logi-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .logi-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .logi-triangle-left,
    .logi-triangle-right {
      width: 36px;
    }

    .logi-title-group h2 {
      font-size: 18px;
    }

    .logi-title-group svg {
      font-size: 24px !important;
      flex-shrink: 0;
    }

    .logi-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .logi-accordion-header {
      font-size: 13px;
      padding: 8px 14px;
    }

    .logi-accordion-arrow {
      font-size: 18px;
    }

    .logi-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .logi-title-group h2 {
      font-size: 15px;
    }

    .logi-accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function LogisticsPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Supplier Fuel Bills Upload",
      content:
        "RPA Bots go through the mails received from the vendors and dealers, and auto-downloads the bill attachments. It also extracts the related data from the bills for further process."
    },
    {
      title: "2.Billing Process",
      content:
        "Provide assist in end-to-end processing of billing associated tasks and sub-processes. Avoids error and reduce time by almost 25% to 30%."
    },
    {
      title: "3.Billing For Leased Vehicles",
      content:
        "RPA helps in validating and releasing payment for the leased vehicles as per the contractual agreement after confirmative the capped amount allowed and estimated credit score."
    },
    {
      title: "4.Vehicle Repair Billing",
      content:
        "Auto-check and approve if the Repair Bills provided by the customers are for valid reasons and all the mandatory details are available."
    },
    {
      title: "5.Accident Repair Bills",
      content:
        "Robot retrieve the accident-related details from the customer system, auto-validate the expenditure, income account, amount and the description. Auto-check details of the vehicle, repair history, and approvals."
    },
    {
      title: "6.Fuel consumption tracking",
      content:
        "RPA helps to generate a daily, weekly, and monthly inventory account for fuel consumption, available at the shop, and purchased. Also navigate to the business system and customer website to get the fuel details."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="logi-header">
        {/* LEFT */}
        <div
          className="logi-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="logi-header-overlay" />

          <div className="logi-header-badge">
            <div className="logi-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic process automation - Use Cases</span>

            <span className="logi-arrow">›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="logi-header-right">
          <div className="logi-triangle-left" />
          <div className="logi-triangle-right" />

          <div className="logi-title-group">
            <FaTruck style={{ fontSize: "32px", color: "#2fb7a4" }} />
            <h2>Logistics</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="logi-main">
        {/* IMAGE */}
        <div className="logi-img-wrapper">
          <img src={logisticsImg} alt="" />
        </div>

        {/* ACCORDION */}
        <div className="logi-accordion">
          {data.map((item, i) => (
            <div key={i} className="logi-accordion-item">
              <div
                className="logi-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="logi-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="logi-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LogisticsPage;
